import { useMemo, useState } from "react";
import { dramas } from "@/mocks/dramas";
import { genreTabs } from "@/mocks/site";
import DramaCard from "@/pages/home/components/DramaCard";
import SectionHeading from "@/pages/home/components/SectionHeading";
import Reveal from "@/components/feature/Reveal";

const HIGH_SCORE = 8.4;

export default function TopRated() {
  const [active, setActive] = useState("全部");

  const pool = useMemo(
    () =>
      dramas
        .filter((d) => d.score >= HIGH_SCORE)
        .sort((a, b) => b.score - a.score),
    [],
  );

  const list = useMemo(
    () =>
      active === "全部"
        ? pool
        : pool.filter((d) => d.genres.includes(active)),
    [pool, active],
  );

  return (
    <section id="top-rated" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Top Rated"
          title="高分韩剧推荐"
          desc="以下为观众综合评分在 8.4 分及以上的剧集。可以按题材切换筛选，快速定位你偏爱的类型。评分反映整体口碑，建议结合剧情简介判断是否合口味。"
        />

        <div className="mt-6 flex flex-wrap gap-2" role="tablist" aria-label="按题材筛选高分韩剧">
          {genreTabs.map((tab) => {
            const selected = tab === active;
            return (
              <button
                key={tab}
                type="button"
                role="tab"
                aria-selected={selected}
                onClick={() => setActive(tab)}
                className={`px-4 py-2 rounded-full text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
                  selected
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 border border-background-300/70 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {tab}
              </button>
            );
          })}
        </div>

        <p className="mt-4 text-sm font-label text-foreground-500">
          当前筛选：<span className="text-primary-700 font-medium">{active}</span> · 共{" "}
          {list.length} 部
        </p>

        {list.length > 0 ? (
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {list.map((drama, index) => (
              <Reveal key={drama.id} delay={(index % 3) * 80}>
                <DramaCard drama={drama} />
              </Reveal>
            ))}
          </div>
        ) : (
          <div className="mt-6 rounded-lg border border-background-200 bg-background-100 px-6 py-12 text-center">
            <span className="w-12 h-12 mx-auto rounded-full bg-background-200 flex items-center justify-center">
              <i className="ri-emotion-line text-xl text-foreground-500" aria-hidden="true" />
            </span>
            <p className="mt-3 text-sm font-label text-foreground-600">
              目前没有该题材的高分剧集，换个题材看看吧。
            </p>
          </div>
        )}
      </div>
    </section>
  );
}